/* eslint-disable */
export default {
  account: 'Tili',
  contact: 'Yhteystieto',
  lead: 'Liidi',
  opportunity: 'Mahdollisuus',
  case: 'Tapaus',
  chooseEntity: 'Anna entiteetin tyyppi',
  create: 'Luo',
} as const;

// @key: @#@"account"@#@ @source: @#@"Account"@#@
// @key: @#@"contact"@#@ @source: @#@"Contact"@#@
// @key: @#@"lead"@#@ @source: @#@"Lead"@#@
// @key: @#@"opportunity"@#@ @source: @#@"Opportunity"@#@
// @key: @#@"case"@#@ @source: @#@"Case"@#@
// @key: @#@"chooseEntity"@#@ @source: @#@"Please select entity type"@#@
// @key: @#@"create"@#@ @source: @#@"Create"@#@
